// components
import { Typography } from '@mui/material';
import { SmartActionComponentProps } from '../SmartActionDialog.types';
import { SmartAction } from './SmartAction';

// hooks
import { useTranslation } from 'react-i18next';

export const OverlapAction = ({
  state,
  messages = []
}: SmartActionComponentProps & { messages?: string[] }) => {
  const MAX_LINES = 5;

  const { t } = useTranslation('common', { keyPrefix: 'mrp' });

  return (
    <SmartAction state={state} title={t('dialogs.overlap.title')}>
      {messages.length > 0 &&
        messages
          .filter((_, index) => index < MAX_LINES)
          .map((message) => <Typography variant="body1">{message}</Typography>)}
      {messages.length > MAX_LINES && (
        <Typography variant="body1">
          • {t('dialogs.overlap.more', { count: messages.length - MAX_LINES })}
        </Typography>
      )}
    </SmartAction>
  );
};
